<div class='trade-in-container'>
  <form [formGroup]='tradeInForm'>
    <div class='trade-in-vehicles'>

      <mat-expansion-panel *ngIf="from !== 'learning' && isTradeInEnabled" #tradeIn [disabled]='!tradeInCheckbox.checked' [expanded]='tradeInCheckbox.checked'>
        <mat-expansion-panel-header [ngClass] = "{'show-cursor' : !tradeInCheckbox.checked}">
          <mat-panel-title>
            <mat-checkbox #tradeInCheckbox disableRipple formControlName='tradeInCheckbox'>
            </mat-checkbox>
            <span class='checkbox-text'>{{ 'testDrive.doesTheCustomerhaveaTradeIns' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div>
          <div class='select-from-existing' *ngIf="ownVehicleAvailable">
            <div class='header'>{{ 'testDrive.selectTheTradeInVehicle' | translate}}</div>
            <div class='vehicles'>
              <div class='vehicle-card' *ngFor="let vehicle of vehicles;let i=index;">
                <label class='vehicle-label'>
                  <mat-checkbox [checked]="vehicle.isChecked" [hidden]="true" [value]='vehicle'
                    name='vehicle' (change)="setVehicle($event, vehicle, i)"></mat-checkbox>
                  <div class='vehicle'>
                    <img [src]="vehicle.carImage" (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')"  alt="Vehicle image"  />
                    <div class='nickname'>{{vehicle.nickName}}</div>
                    <div class='make-model-year'>{{vehicle.make + ' ' +  vehicle.model + ' ' + vehicle.year}}</div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div id="or" *ngIf="ownVehicleAvailable">{{ 'testDrive.or' | translate}}</div>

          <div class='choose-new'>
            <div class='choose-new-header'>
              <div class='header'>{{ 'testDrive.enterTheTradeInVehicleDetails' | translate}}</div>
            </div>
            <div formArrayName='vehicle'>
              <div class='dropdown' *ngFor="let other of vehicleArray?.controls, let i = index, first as isFirst"
                  [formGroupName]="i">
                  <div  *ngIf="ownVehicleAvailable ? !other.value.isOwnVehicle : true">
                    <app-splitter *ngIf="ownVehicleAvailable ? !isFirstmanualVehicle(i) : !isFirst" class="app-splitter mx-3" [config]="'horizontal 100% 0 0.5rem'"></app-splitter>
                    <div class="choose-new-content">

              <div>
                <label>{{ 'testDrive.year' | translate}}<span style="color:red">*</span></label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName='year' required aspNumberOnly maxlength="4">
                  <mat-error *ngIf="other.controls['year'].invalid">
                    {{'testDrive.pleaseEnterAValidYear' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div>
                <label>{{'service.make' | translate}}<span style="color:red">*</span></label>
                <mat-form-field  appearance="outline">
                  <input matInput formControlName='make' required>
                  <mat-error *ngIf="other.controls['make'].invalid">
                    {{'testDrive.pleaseEnterAValidMake' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div>
                <label>{{ 'testDrive.model' | translate}}<span style="color:red">*</span></label>
                <mat-form-field  appearance="outline" 
                [ngClass]="(ownVehicleAvailable || !(!ownVehicleAvailable && vehicleArray?.length === 1)) ? 'reduce-width' : '' ">
                  <input matInput formControlName='model' required>
                  <mat-error *ngIf="other.controls['model'].invalid">
                    {{'testDrive.pleaseEnterAValidModel' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div>
                <label>{{ 'testDrive.trim' | translate}}</label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName='trim'>
                </mat-form-field>
              </div>

              <div>
                <label>VIN</label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName='vin' maxlength="17">
                </mat-form-field>
              </div>

              <div>
                <label>{{ 'testDrive.estimatedMileage' | translate}}</label>
                <div style="flex-direction: row;">
                <mat-form-field appearance="outline">
                  <input matInput formControlName='mileage' aspNumberOnly>
                </mat-form-field>
                <div  *ngIf="!(!ownVehicleAvailable && i===0 && vehicleArray?.length === 1)" class="mt-4"
                [title]="'delivery.deleteVehicle' | translate" style="cursor: pointer;">
                <asp-icon class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                        color="rgba(14,19,25,0.8)" (click)='onDeleteVehicle(i)'>
                </asp-icon>
              </div>
            </div>
          </div>

       </div>
     </div>
   </div>
  </div>

   <div  class='action' (click)='onAddVehicle()' [ngClass]="{'disabled': manualEntryVehicles()?.length >= maxManualTradeInVehicle}"
    [ngStyle]="{'margin-left' : (ownVehicleAvailable || !(!ownVehicleAvailable && vehicleArray?.length === 1)) ? '84.5%' : '86%' }">
          <div class="box">
              <div class="plus">+</div>
          </div>
          <div class="btnText" >{{('vehicleManagement.addVehicle' | translate) }}</div>
   </div>
  </div>

            <ng-container *ngIf="from === 'delivery'">
              <div class="delivery-tradein">
                <div class="row">
                  <div class="col-md-6">
                    <label>{{'testDrive.title' | translate}}</label>
                    <mat-form-field appearance="outline" class="mat-input-container full-width">
                      <input type="text" matInput [placeholder]="'testDrive.title' | translate" formControlName='title'>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label>{{'testDrive.authorizedRepresentativeInfo' | translate}}</label>
                    <mat-form-field appearance="outline" class="mat-input-container full-width">
                      <input type="text" matInput [placeholder]="'testDrive.authorizedRepresentativeInfo' | translate"
                        formControlName='trepresentativeInfo'>
                    </mat-form-field>
                  </div>

                </div>
                <div class="row comments">
                  <div class="col-md-6">
                    <label>{{'generalSettings.comments' | translate}}</label>
                    <mat-form-field appearance="outline" class="mat-input-container full-width">
                      <input type="text" matInput [placeholder]="'generalSettings.comments' | translate" formControlName='tradeInComments'>
                    </mat-form-field>
                  </div>
                </div>
                
              </div>
            </ng-container>
          </div>
      </mat-expansion-panel>      
      <mat-expansion-panel [ngStyle]="{'margin-top': (from === 'learning' || isTradeInEnabled) ? '2rem' : '0'}">
        <mat-expansion-panel-header>
        <mat-panel-title>
            <div>
                {{ 'delivery.commentsFromDealer' | translate}}
            </div>
        </mat-panel-title>
        </mat-expansion-panel-header>
            <mat-form-field class="no-fixed-height comment-width" appearance="outline">
            <textarea matInput #dealerCommentsTextArea rows='5' formControlName='dealerComments' maxlength="250" placeholder="{{ 'delivery.placeHolderComments' | translate}}"></textarea>
            </mat-form-field>
            <mat-hint style="display: flex; flex-direction: row-reverse; font-size: 0.8rem; font-weight: bold;">{{dealerCommentsTextArea.value?.length || 0}}/250 {{ 'delivery.characters' | translate}}</mat-hint>
    </mat-expansion-panel>

    <mat-expansion-panel style="margin-top: 2rem;">
      <mat-expansion-panel-header>
      <mat-panel-title>
          <div>
              {{ 'delivery.internalDealerComments' | translate}}
          </div>
      </mat-panel-title>
      </mat-expansion-panel-header>
          <mat-form-field class="no-fixed-height comment-width" appearance="outline">
          <textarea matInput #internalCommentsTextArea rows='5' formControlName='internalComments' maxlength="250" placeholder="{{ 'delivery.placeHolderComments' | translate}}"></textarea>
          </mat-form-field>
          <mat-hint style="display: flex; flex-direction: row-reverse; font-size: 0.8rem; font-weight: bold;">{{internalCommentsTextArea.value?.length || 0}}/250 characters</mat-hint>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="checkAdditonalComment()" style="margin-top: 2rem;">
    <mat-expansion-panel-header>
    <mat-panel-title>
        <div>
            {{ 'delivery.customerComments' | translate}}
        </div>
    </mat-panel-title>
    </mat-expansion-panel-header>
        <mat-form-field class="no-fixed-height comment-width" appearance="fill">
        <textarea matInput rows='5' formControlName='additionalComments' maxlength="250" readonly></textarea>
        </mat-form-field>
  </mat-expansion-panel>

    </div>
  </form>
</div>